import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default api;

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const FIELDS = [
  { value: "education-youth", label: "Education & Youth" },
  { value: "public-health-care", label: "Public Health & Care" },
  { value: "environmental-sustainability", label: "Environmental Sustainability" },
  { value: "arts-culture-humanities", label: "Arts, Culture & Humanities" },
  { value: "economy-labor", label: "Economy & Labor" },
];

export const LANGUAGES = [
  "English", "Spanish", "French", "Portuguese", "Arabic", "Chinese", "Swahili", "Hindi", "Other",
];
